<template>
  <div class="page page-history">
    <Chart />
  </div>
</template>

<script>
  import Chart from '@/components/history/Chart'

  export default {
    name: 'page-history',
    components: {
      Chart,
    },
  }
</script>

<style lang="scss">
  .page-history {
    padding-bottom: 0;
    max-width: 1300px;
  }
</style>
